var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AsrAutoComplete',_vm._g(_vm._b({ref:"autocompleteRef",attrs:{"placeholder":" "},on:{"select":_vm.onSelect,"change":_vm.onChange,"clear":_vm.onClear},model:{value:(_vm.proxyValue),callback:function ($$v) {_vm.proxyValue=$$v},expression:"proxyValue"}},'AsrAutoComplete',_vm.proxyProps,false),_vm.proxyEvents))
}
var staticRenderFns = []

export { render, staticRenderFns }